import { PartnerTagModelBase } from "./PartnerTagModel.base"


/* A graphql query fragment builders for PartnerTagModel */
export { selectFromPartnerTag, partnerTagModelPrimitives, PartnerTagModelSelector } from "./PartnerTagModel.base"

/**
 * PartnerTagModel
 *
 * A Partner Tag
 */
export const PartnerTagModel = PartnerTagModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
